import {useGoogleLogin as useAuthGoogleLogin} from '@react-oauth/google';

export const useGoogleLogin = props => {
  return useAuthGoogleLogin({flow: 'auth-code', ...props});
};

export const googleSignOut = () => {};
